module.exports = __webpack_public_path__ + "static/javier-chavarri.da56d777.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/javier-chavarri.jpg
// module id = 667
// module chunks = 168707334958949